export const TRIGGER_ACTIONS_LOAD = 'TRIGGER_ACTIONS_LOAD';
export const TRIGGER_ACTIONS_LOAD_SUCCESS = 'TRIGGER_ACTIONS_LOAD_SUCCESS';
export const TRIGGER_ACTIONS_LOAD_ERROR = 'TRIGGER_ACTIONS_LOAD_ERROR';
export const TRIGGER_ACTION_ADD = 'TRIGGER_ACTION_ADD';
export const TRIGGER_ACTION_ADD_SUCCESS = 'TRIGGER_ACTION_ADD_SUCCESS';
export const TRIGGER_ACTION_ADD_ERROR = 'TRIGGER_ACTION_ADD_ERROR';
export const TRIGGER_ACTION_UPDATE = 'TRIGGER_ACTION_UPDATE';
export const TRIGGER_ACTION_UPDATE_SUCCESS = 'TRIGGER_ACTION_UPDATE_SUCCESS';
export const TRIGGER_ACTION_UPDATE_ERROR = 'TRIGGER_ACTION_UPDATE_ERROR';
export const TRIGGER_ACTION_DELETE = 'TRIGGER_ACTION_DELETE';
export const TRIGGER_ACTION_DELETE_SUCCESS = 'TRIGGER_ACTION_DELETE_SUCCESS';
export const TRIGGER_ACTION_DELETE_ERROR = 'TRIGGER_ACTION_DELETE_ERROR';
